import { projectApi } from '@/model/project/api.generated';

export function registerProjectTags(): void {
  projectApi.enhanceEndpoints({
    endpoints: {
      getApiProjectsByProjectIdMembersInvitations: {
        providesTags: ['project-members'],
      },
      projectGetMembersIdpSubs: {
        providesTags: ['project-members'],
      },
      postApiProjectsByProjectIdMembers: {
        invalidatesTags: ['project-members', 'permissions'],
      },
      patchApiProjectsByProjectIdMembersAndUserIdRole: {
        invalidatesTags: ['project-members', 'permissions'],
      },
      deleteApiProjectsByProjectIdMembersAndUserId: {
        invalidatesTags: ['project-members', 'permissions'],
      },
      deleteApiProjectsByProjectIdMembersInvitationsAndInvitationId: {
        invalidatesTags: ['project-members'],
      },
    },
  });
}
